import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["prefix", "suffix", "value", "InputProps", "placeholder", "label"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//@ts-nocheck
import { makeStyles, InputAdornment, TextField as MuiTextField, RaiseColors } from "components/mui";
import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var useStyles = makeStyles(function () {
  return {
    inputRoot: {
      whiteSpace: "pre-wrap",
      backgroundColor: RaiseColors.white,
      borderRadius: "8px",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: RaiseColors.grayscale200
      }
    },
    input: {
      paddingLeft: "16px",
      paddingRight: "16px",
      paddingTop: "8px",
      paddingBottom: "8px",
      fontSize: "14px"
    }
  };
});
function RaiseInputTextField(_ref) {
  var prefix = _ref.prefix,
    suffix = _ref.suffix,
    value = _ref.value,
    _ref$InputProps = _ref.InputProps,
    InputProps = _ref$InputProps === void 0 ? {} : _ref$InputProps,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? "" : _ref$placeholder,
    label = _ref.label,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  InputProps.classes = _objectSpread({
    root: classes.inputRoot,
    input: classes.input
  }, InputProps.classes);
  InputProps.disableUnderline = true; // assumes variant is standard
  if (prefix) {
    InputProps.startAdornment = /*#__PURE__*/_jsx(InputAdornment, {
      position: "start",
      children: prefix
    });
  }
  if (suffix) {
    InputProps.endAdornment = /*#__PURE__*/_jsx(InputAdornment, {
      position: "end",
      children: suffix
    });
  }
  return /*#__PURE__*/_jsx(MuiTextField, _objectSpread(_objectSpread({}, props), {}, {
    fullWidth: true,
    placeholder: placeholder,
    style: {
      paddingLeft: "0px"
    },
    InputProps: InputProps,
    value: value || "" // "" to stop uncontrolled input errors from React
    ,
    variant: "outlined"
  }));
}
export default RaiseInputTextField;